import React from 'react';
import {ReactComponent as LoaderIcon} from '../../images/loader-icon.svg';
const SubmitButton = ({
  text = '',
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  isLoading = false,
  id = 'default',
  ref,
}) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={`auth-forms__button ${className}`}
    >
      {isLoading ? <LoaderIcon /> : text}
    </button>
  );
};

export default SubmitButton;
